import React, {useState} from "react";
import Modal from "react-bootstrap/Modal";
import I18n from 'i18n.js.erb'

const RequiredLoginAlertPopup = ({showRequiredLoginAlertPopup, onClose}) => {

  // Funzione che gestisce la chiusura della modale
  const handleClose = () => onClose(false)

  return (
    <Modal show={showRequiredLoginAlertPopup} onHide={handleClose} animation={false} size="lg"
           centered>
      <Modal.Header>
        <Modal.Title>{I18n.t('js.requiredLoginAlertPopup.title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{I18n.t('js.requiredLoginAlertPopup.content')}</p>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn-standard-outline br-20px pr-2 pl-2 w-120px btn-standard-outline-resized"
          onClick={handleClose}>
          {I18n.t('js.common.button.cancel')}
        </button>
        <button
          type="button"
          className="btn-standard bg-aig-gradient text-light br-20px pr-2 pl-2 w-120px btn-standard-resized pt-4px-imp h-35px"
          onClick={() => window.location.href = `/users/sign_in`}>
          {I18n.t('js.requiredLoginAlertPopup.goToLogin')}
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default RequiredLoginAlertPopup;